import React from 'react';
import { tz } from 'moment-timezone';
import PropTypes from 'prop-types';
import DataCard from 'components/common/card/DataCard';
import { formatOrderNotificationLogs } from 'utils/formatters/formatOrderNotificationLogs';

export const Notification = ({ data = [] }) => {
  const formattedNotifications = formatOrderNotificationLogs(data);

  const details = formattedNotifications?.length
    ? formattedNotifications.map((item) => `${item.label} \n`)
    : 'No notifications sent for this order';

  return <DataCard title="Notifications" cardData={[{ data: details }]} />;
};

Notification.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      notifiedAt: PropTypes.string,
      status: PropTypes.string,
      language: PropTypes.shape({ language: PropTypes.string }),
    }),
  ),
};
